module.exports = __webpack_public_path__ + "svg/tape-measure.c43caccf15fa34dcba5b5424d339f162.svg";